// src/features/suppliers/pages/SuppliersPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const StockMedicinesPage = () => {
  return <MasterDataListPage type="medicines" />;
};

export default StockMedicinesPage;